export const categories = [
  {
    slug: 'mingxing',
    name: '明星黑料',
    description: '明星艺人最新黑料爆料，一手掌握娱乐圈明星不为人知的秘密',
    icon: 'ri-star-line',
    count: 45,
  },
  {
    slug: 'wanghong',
    name: '网红黑料',
    description: '网红主播、短视频博主翻车现场，黑历史全记录',
    icon: 'ri-live-line',
    count: 38,
  },
  {
    slug: 'yulequan',
    name: '娱乐圈',
    description: '娱乐圈潜规则、行业黑幕，深度揭秘娱乐圈那些事',
    icon: 'ri-movie-line',
    count: 52,
  },
  {
    slug: 'bagua',
    name: '八卦爆料',
    description: '最新八卦花边新闻，吃瓜群众必看的每日爆料合集',
    icon: 'ri-chat-smile-2-line',
    count: 67,
  },
  {
    slug: 'neimu',
    name: '内幕揭秘',
    description: '独家深度调查，揭露行业黑幕与资本运作真相',
    icon: 'ri-spy-line',
    count: 23,
  },
];